import { InputConfig, validateEmail } from "@cpj-ai/panel-npm-package";

export const defaultValues = {
  email: "",
};

export const inputConfigs: InputConfig[] = [
  {
    name: "email",
    previewSize: 12,
    inputProps: {
      type: "text",
      label: "Email:",
      placeholder: "Enter your email",
    },
    rules: {
      required: "Email is required",
      validate: (value) => {
        const emailResult = validateEmail(value);
        return emailResult.isValid ? true : emailResult.message;
      },
    },
  },
];
